import __request__ from 'routing/request';
interface DetectionChainEventsResponse {
    readonly event_count: number;
    readonly event_ids: string[];
    readonly id: string;
}
interface DetectionChainSummary {
    readonly part_of_detection_chain: boolean;
    readonly rules: DetectionChainSummary__Rule[];
    readonly id: string;
    readonly title: string;
}
interface DetectionChainSummary__Rule {
    readonly db_id: string;
    readonly id: string;
    readonly title: string;
    readonly seen: boolean;
}
/**
 * Get Events for a Threat Campaign.
 */
export function getEventsForThreatChain(id: string): Promise<DetectionChainEventsResponse> {
    return __request__('GET', `/plugins/org.graylog.plugins.securityapp/threat_campaigns/events_for_threat_campaign/${id}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get Threat Campaign details for an Event.
 */
export function getSummary(eventId: string): Promise<DetectionChainSummary> {
    return __request__('GET', `/plugins/org.graylog.plugins.securityapp/threat_campaigns/summary_for_event/${eventId}`, null, {}, {
        'Accept': ['application/json']
    });
}
